<template>
  <v-select
    v-model="categoryProxy"
    :items="categories"
    :label="label"
    :hint="hint"
    :error-messages="errorMessages"
    persistent-hint
    item-text="title"
    return-object
    :outlined="outline"
    color="primary"
    value="id"
  >
  </v-select>
</template>

<script>
import CategoryService from '@/services/categories'
export default {
  name: 'CategorySelector',
  props: {
    outline: {type: Boolean, required: false},
    value: {type: Object, required: true},
    label: {type: String, required: false, default: ''},
    hint: {type: String, required: false, default: ''},
    errorMessages: {type: Array, required: false, default: () => []}
  },
  data: () => ({
    categories: []
  }),
  computed: {
    categoryProxy: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  async created () {
    this.categories = await CategoryService.getAll()
  }
}
</script>